import { Skeleton } from '@/core/ui';

export const ChatSkeleton = ({ isCurrentUser = false }: { isCurrentUser?: boolean }) => {
  if (isCurrentUser) {
    // Right side (current user)
    return (
      <div className='flex items-start gap-2 justify-end animate-pulse'>
        <div className='text-right'>
          <div className='flex items-center gap-2 justify-end mb-1'>
            <Skeleton className='h-3 w-16 rounded' />
            <Skeleton className='h-3 w-10 rounded' />
          </div>
          <div className='bg-cyan-100 dark:bg-cyan-900 rounded-lg px-3 py-2 mt-1 text-sm text-default-800 w-44 ml-auto'>
            <Skeleton className='h-4 w-32 mb-1 rounded' />
            <Skeleton className='h-4 w-24 rounded' />
          </div>
        </div>
      </div>
    );
  }
  // Left side (other user)
  return (
    <div className='flex items-start gap-2 animate-pulse'>
      <div>
        <div className='flex items-center gap-2 mb-1'>
          <Skeleton className='h-3 w-16 rounded' />
          <Skeleton className='h-3 w-10 rounded' />
        </div>
        <div className='bg-lime-100 dark:bg-lime-900 rounded-lg px-3 py-2 mt-1 text-sm text-default-800 w-44'>
          <Skeleton className='h-4 w-32 mb-1 rounded' />
          <Skeleton className='h-4 w-24 rounded' />
        </div>
      </div>
    </div>
  );
};
